import { LayoutHOC } from 'base/ui/layout/layout';
import createVerifyQR from './verifyQR';

export const createVerifyPage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createVerifyQR());
};
